<template>
  <ul class="accordion-list" :class={active:isActive()}>
    <slot></slot>
  </ul>
</template>

<script>

export default {
  name: 'accordion-list',
  props: {
    active: {type: Boolean}
  },
  methods: {
    isActive: function () {
      return this.active
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .accordion-list {
    &.-disabled {
     background-color: #cccccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accordion/AccordionList.vue